














































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import ApiFactory from "@/api/ApiFactory";
import { PolicyValuesDto } from "@/api/ClientPortalApiClient";
import { format } from "numeral";

@Component
export default class PolicyValues extends Vue {
  @Prop() policyId: number | undefined;
  @Prop() contactId: number | undefined;

  private policyValues: PolicyValuesDto[] | null = null;

  async mounted() {
    await this.getPolicyValues();
  }

  private async getPolicyValues() {
    if (!this.policyId) throw new Error("Policy id not valid");
    const api = ApiFactory.CreateDataClient();
    this.policyValues = await api.values_Policies(this.policyId);
  }
}
